module.exports = __webpack_public_path__ + "img/00040.01b8cc03.webp";